import { IExtractedFilesQueryParams, ISamplesQuery } from "./@types";

export const samplesAvailableSearchQueryKey = (hashes: string[]) => [
  "sample-available",
  hashes
];

export const listSamplesKey = (query: ISamplesQuery | undefined) => [
  "useListSamples",
  query
];

export const getExtractedFilesKey = (
  hash: string | undefined,
  qp?: IExtractedFilesQueryParams
) => ["extractedFiles", hash, qp];
